var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"gmapsWrapper",staticClass:"gmapswrapper",staticStyle:{"width":"100%","position":"absolute"}},[_vm._v("Google Maps wird geladen...")])])}
var staticRenderFns = []

export { render, staticRenderFns }